// Consent + Legal API — Phase 1 Plan 04 endpoints, consumed in Plan 05 ConsentScreen.
//
// Note: docstring references ApiClient — но фактически recordConsent/fetchLegalDoc
// принимают baseUrl + initDataRaw напрямую, без типизированного клиента, поэтому
// импорт не нужен.

export interface LegalDocResponse {
  audience: string;
  locale: string;
  version: string;
  markdown: string;
  sha256: string;
}

export interface ConsentResponse {
  id: number;
  user_id: number;
  audience: string;
  policy_version: string;
  locale: string;
  legal_basis: string;
  consent_text_hash: string;
  granted_at: string;
}

export interface ConsentRequest {
  audience: "dispatcher" | "driver" | "customer";
  policy_version: string;
  locale: string;
  legal_basis: "consent" | "legitimate_interest" | "contract";
}

/**
 * Fetch privacy policy Markdown text — public endpoint, no auth.
 */
export async function getLegal(
  baseUrl: string,
  audience: string,
  locale: string,
  version = "1.0",
): Promise<LegalDocResponse> {
  const url = `${baseUrl}/api/v1/legal/${encodeURIComponent(audience)}?locale=${encodeURIComponent(locale)}&version=${encodeURIComponent(version)}`;
  const res = await fetch(url, { headers: { Accept: "application/json" } });
  if (!res.ok) {
    throw new Error(`Failed to fetch legal: ${res.status}`);
  }
  return (await res.json()) as LegalDocResponse;
}

/**
 * Record user's privacy policy acceptance — requires X-Init-Data header
 * (handled by ApiClient interceptor via initData passthrough — see AuthContext).
 *
 * @param client - configured ApiClient (но также может work без auth — uses
 *                 X-Init-Data instead of Bearer). Pass initDataRaw via fetch options.
 */
export async function recordConsent(
  baseUrl: string,
  initDataRaw: string,
  body: ConsentRequest,
): Promise<ConsentResponse> {
  const res = await fetch(`${baseUrl}/api/v1/consent`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-Init-Data": initDataRaw,
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Consent record failed: ${res.status} ${text}`);
  }
  return (await res.json()) as ConsentResponse;
}
